import styled from 'styled-components';

import { token, spaceMixin, IconCheckmarkCircleOutline } from '@zillow/constellation';

export const StyledContainer = styled.div`
    text-align: center;
    margin-bottom: ${spaceMixin('lg')};
`;

export const StyledIcon = styled(IconCheckmarkCircleOutline)`
    && {
        color: ${token('colors.green400')};
        height: 100px;
        width: 100px;
        margin-bottom: ${spaceMixin('xs')};
    }
`;
